import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';

import RouteConfig from './RouteConfig';
function App() {
  return (
    <>
      <RouteConfig />
      <ToastContainer />
    </>
  );
}

export default App;
